import React from 'react';
import { Wrapper, WrapperUL, WrapperLi } from "./LeadsDetailsSteps.styled"


const LeadsDetailsSteps = ({ label }) => {
    const labels = { new: 1, sit: 2, sold: 3, m1: 4, m2: 5 }
    const labelList = [
        { name: 'New', rank: 1 },
        { name: 'Sit', rank: 2 },
        { name: 'Sold', rank: 3 },
        { name: 'M1', rank: 4 },
        { name: 'M2', rank: 5 },
    ];
    const step = labels[`${label}`.toLocaleLowerCase()] || 1;


    return (
        <Wrapper>
            <WrapperUL>
                {labelList.map((lab) => (
                    <WrapperLi active={lab.rank-1 <= step}>
                        <div className='title'>{lab.name}</div>
                        <div className='circle'>
                            {lab.rank <= step ? <div className='checkmark'></div> : <div class="dot"></div>}
                        </div>
                    </WrapperLi>
                ))}
            </WrapperUL>
        </Wrapper>
    )
}

export default LeadsDetailsSteps;
